import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import CustomFieldInput from './CustomFieldInput';
import CustomFieldSelect from './CustomFieldSelect';
import RequiredAsterisk from './RequiredAsterisk';
import InfoIcon from './InfoIcon';
import { FormField } from '../../../generated/graphql';

const CustomFieldComponent = ({ field }: { field: FormField }) => {
  const {
    _id: id,
    label,
    description,
    type,
    options,
    placeholder,
    isMultiselect,
    isRequired,
  } = field;

  const renderSwitch = () => {
    switch (true) {
      case type === 'free_text': {
        return (
          <CustomFieldInput
            id={id}
            placeholder={placeholder || undefined}
          />
        );
      }

      case type === 'enum': {
        return (
          <CustomFieldSelect
            id={id}
            options={options || []}
            placeholder={placeholder || undefined}
            isMultiselect={isMultiselect || false}
          />
        );
      }

      default: return null;
    }
  };

  return (
    <FormGroup>
      <Label for={id} className="mb-0">
        {label}
        {isRequired && <RequiredAsterisk />}
        {description && <InfoIcon text={description} />}
      </Label>
      {renderSwitch()}
    </FormGroup>
  );
};

export default CustomFieldComponent;
